module.exports = __webpack_public_path__ + "4c995bd1af40d0ec47c56b6fc835df7f.svg";